import { render, staticRenderFns } from "@/templates/socialMedia.html?vue&type=template&id=163b7f20&scoped=true&"
import script from "./socialMedia.vue?vue&type=script&lang=js&"
export * from "./socialMedia.vue?vue&type=script&lang=js&"
import style0 from "./socialMedia.vue?vue&type=style&index=0&id=163b7f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b7f20",
  null
  
)

export default component.exports